import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { LogService } from 'src/app/shared/services/log.service';
import { CSForm } from '../models/cs-form.model';
import { FormAdmin } from '../../admin/edit-form/form-admin.model';
import { FormTransaction } from '../models/form-transaction.model';

@Injectable({ providedIn: 'root' })
export class FormTransactionService {
  apiHost: string = environment.apiHost;
  constructor(private http: HttpClient, private logService: LogService) {}

  getFormTransaction(id: number): Promise<FormTransaction> {
    let promise = new Promise<FormTransaction>((resolve, reject) => {
      return this.http
        .get<FormTransaction>(
          this.apiHost + '/FormTransaction/Get?FormTransactionId=' + id
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog(
                'Admin: Get Form Transaction Id=' + id,
                msg
              );
            reject(msg);
          }
        );
    });
    return promise;
  }

  addFormTransaction(addFormTransaction: FormTransaction): Promise<any> {
    let promise = new Promise<any>((resolve, reject) => {
      return this.http
        .post<any>(
          this.apiHost + '/FormTransaction/AddFormTransaction',
          addFormTransaction
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog(
                'Admin: Add Form Transaction ' + addFormTransaction.id,
                msg
              );
            reject(msg);
          }
        );
    });
    return promise;
  }

  updateFormTransaction(updateFormTransaction: FormTransaction): Promise<any> {
    let promise = new Promise<any>((resolve, reject) => {
      return this.http
        .post<any>(
          this.apiHost + '/FormTransaction/UpdateFormTransaction',
          updateFormTransaction
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog(
                'Admin: Add Form ' + updateFormTransaction.id,
                msg
              );
            reject(msg);
          }
        );
    });
    return promise;
  }

  deleteFormTransaction(id: number): Promise<any> {
    let promise = new Promise<any>((resolve, reject) => {
      return this.http
        .post<any>(
          this.apiHost +
            '/FormTransaction/DeleteFormTransaction?FormTransactionId=' +
            id,
          null
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog(
                'Admin: Delete Form Transaction ' + id.toString(),
                msg
              );
            reject(msg);
          }
        );
    });
    return promise;
  }

  getAllFormTransactions(formId: number): Promise<FormTransaction[]> {
    let promise = new Promise<FormTransaction[]>((resolve, reject) => {
      return this.http
        .get<FormTransaction[]>(
          this.apiHost +
            '/FormTransaction/GetAllFormTransactions?formId=' +
            formId
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Get All Form Transactions', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }
}
